var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoundcreation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.882,
    height: 22.93,
    viewBox: "0 0 27.882 22.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.63 -4.164)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.78 4.352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.644,10.794a.485.485,0,1,0-.757.606,7.1,7.1,0,0,1,0,8.872.485.485,0,0,0,.758.605,8.071,8.071,0,0,0,0-10.083Z",
    transform: "translate(-2.323 -4.541)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.852,6.82a.484.484,0,1,0-.6.763,10.325,10.325,0,0,1,0,16.273.485.485,0,0,0,.6.763,11.291,11.291,0,0,0,0-17.8Z",
    transform: "translate(-2.362 -4.423)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.567,4.454a.485.485,0,0,0-.6.764,13.236,13.236,0,0,1,0,20.861.485.485,0,0,0,.6.763,14.2,14.2,0,0,0,0-22.388Z",
    transform: "translate(-2.444 -4.352)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.793,6.486a1.488,1.488,0,0,0-.869.281L9.868,10.379H7.114a5.334,5.334,0,0,0,0,10.668H9.868l5.056,3.613A1.5,1.5,0,0,0,17.3,23.438V7.988A1.505,1.505,0,0,0,15.793,6.486Zm.534,16.952a.533.533,0,0,1-.839.431l-5.183-3.7a.484.484,0,0,0-.282-.09H7.114a4.364,4.364,0,0,1,0-8.728h2.909a.491.491,0,0,0,.282-.09l5.183-3.7a.533.533,0,0,1,.839.432Z",
    transform: "translate(-1.78 -4.416)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundcreation);
export default __webpack_public_path__ + "static/media/soundcreation.1038051e.svg";
export { ForwardRef as ReactComponent };